import type { Ref } from 'vue'

import { storeToRefs } from 'pinia'

import { useEventsDirectorySearchStore } from '../stores/events-directory-search.ui-store'

export const EVENTS_DIRECTORY_SEARCH_DEBOUNCE_MS = 300

export interface UseEventsDirectorySearch {
  /** Current search query shared between the shell top bar and the directory grid. */
  searchQuery: Ref<string>
  /** Update the shared search query. */
  setSearchQuery: (value: string) => void
  /** Clear the shared search query. */
  reset: () => void
}

/**
 * Component-facing API for the shared events directory search state.
 *
 * Wraps the Pinia UI store so components depend on the composable boundary
 * (Component → Composable → Store) instead of importing the store directly.
 */
export function useEventsDirectorySearch(): UseEventsDirectorySearch {
  const store = useEventsDirectorySearchStore()
  const { searchQuery } = storeToRefs(store)

  return {
    searchQuery,
    setSearchQuery: store.setSearchQuery,
    reset: store.reset,
  }
}
